import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png';

const LockScreen = ({ history }) => {
  const onSubmit = (e) => {
    e.preventDefault();
    history.push('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <Link to="/dashboard" className="inline-block mb-4">
              <img src={logo} alt="Logo" className="h-12" />
            </Link>
            <h2 className="text-2xl font-bold text-gray-900">Lock Screen</h2>
            <p className="text-gray-600 mt-2">
              Enter your password to unlock the screen
            </p>
          </div>
          <form onSubmit={(e) => onSubmit(e)}>
            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                type="password"
                id="password"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0E4B4B] focus:border-transparent"
                placeholder="Enter your password"
              />
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 bg-[#0E4B4B] text-white rounded-md hover:bg-[#126F6F] focus:outline-none focus:ring-2 focus:ring-[#0E4B4B] focus:ring-offset-2 transition-colors duration-200"
            >
              Unlock
            </button>
          </form>
          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="text-sm text-[#0E4B4B] hover:text-[#126F6F] font-medium"
            >
              Sign in as different user
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockScreen;
